import { HttpInterceptorFn } from "@angular/common/http";
import { environment } from "../../../environments/environment";

export const portalApiInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.startsWith("/v1/")) {
    const apiReq = req.clone({
      url: `${environment.apiURL}${req.url}`,
    });
    return next(apiReq);
  }
  return next(req);
};
